import { doc, getDoc, collection, query, where, limit, getDocs } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Decide where a verified phone number's "Track" tap should land.
 *
 * Rakhi Express bookings live in their own isolated collection
 * (rakhiExpressBookings — see functions/rakhiExpress.js) that Dashboard.jsx
 * doesn't know about by design. Without this check, a phone with ONLY a
 * Rakhi booking (no normal Sender/TravelerRequest) would land on an empty
 * /dashboard. Anyone with a normal request keeps going to /dashboard,
 * completely unchanged — this only adds a branch for the Rakhi-only case.
 */
// Cached per phone for the tab's lifetime. Tapping Track, going back home and
// tapping Track again used to repeat the whole Firestore round trip every
// time; the answer only changes when a user's first request is created, which
// is not something that happens between two taps. sessionStorage (not local)
// so it never outlives the tab.
const CACHE_PREFIX = "tx_track_dest_";

export async function resolveTrackDestination(phone) {
  try {
    const cached = sessionStorage.getItem(CACHE_PREFIX + phone);
    if (cached) return cached;
  } catch { /* private mode / storage disabled — just resolve it live */ }

  let dest = "/dashboard";
  try {
    const userSnap = await getDoc(doc(db, "users", phone));
    const hasNormalRequest = userSnap.exists() && !!userSnap.data().latestRequestKey;

    if (!hasNormalRequest) {
      // Rakhi Express is a retired campaign, so this branch is rare — only
      // read it when the user has no normal request, same as before.
      const rakhiQ = query(collection(db, "rakhiExpressBookings"), where("senderPhone", "==", phone), limit(1));
      const rakhiSnap = await getDocs(rakhiQ);
      if (!rakhiSnap.empty) dest = "/rakhi-express/status";
    }
  } catch (err) {
    console.error("resolveTrackDestination error:", err);
    return "/dashboard"; // fail safe — never block Track, and don't cache a failure
  }

  try { sessionStorage.setItem(CACHE_PREFIX + phone, dest); } catch { /* ignore */ }
  return dest;
}
